
import { Link, useLocation } from 'react-router-dom';

interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <Link to="/" className="cursor-pointer">
              <img
                src="https://public.readdy.ai/ai/img_res/72187a25-def1-4356-ac53-62c960b600d4.png"
                alt="Sonoma Routes"
                className="h-12 w-auto"
              />
            </Link>
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/about"
              className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors cursor-pointer"
            >
              About
            </Link>
            {isHomePage ? (
              <>
                <a
                  href="#who-we-serve"
                  className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors cursor-pointer"
                >
                  Who We Serve
                </a>
                <a
                  href="#products"
                  className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors cursor-pointer"
                >
                  Products
                </a>
                <a
                  href="#how-it-works"
                  className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors cursor-pointer"
                >
                  How It Works
                </a>
              </>
            ) : (
              <>
                <Link
                  to="/#who-we-serve"
                  className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors cursor-pointer"
                >
                  Who We Serve
                </Link>
                <Link
                  to="/#products"
                  className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors cursor-pointer"
                >
                  Products
                </Link>
                <Link
                  to="/#how-it-works"
                  className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors cursor-pointer"
                >
                  How It Works
                </Link>
              </>
            )}
            <Link
              to="/contact"
              className="text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors cursor-pointer"
            >
              Contact
            </Link>
            <Link
              to="/contact"
              className="px-6 py-2.5 bg-gray-900 text-white text-sm font-medium rounded-md hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              Get Started
            </Link>
          </div>

          <button className="md:hidden text-gray-900 cursor-pointer">
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
